import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-telefone-movel-pj',
  templateUrl: './telefone-movel-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./telefone-movel-pj.component.css']
})
export class TelefoneMovelPjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.telefone_movel===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.telefone_movel===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
